import type { EntityDto } from '@app/api/dtos'
import type { FilterOption } from '@app/types/filter'

export const getFilterFromEntities = <IdType extends string | number = string>(
  entityResponse?: Array<EntityDto<IdType>> | null
): FilterOption[] => {
  return (
    entityResponse?.map(({ id, name }) => ({
      value: id,
      label: name
    })) ?? []
  )
}
